// eslint-disable-next-line import/prefer-default-export
export const REQUIRED_ERROR = 'This field is required';

export const DEFAULT_FILE_NAME = 'downloadedFile.png';
